module.exports = __webpack_public_path__ + "img/hr.42de8005.svg";